export const SAVE_SETTINGS = "save_settings"

export const saveSettings = (settings) => {
    window.localStorage.setItem('app.contractCode', settings.contractCode)
    window.localStorage.setItem('app.apiKey', settings.apiKey)
    return{
        type : SAVE_SETTINGS, 
        payload : settings
    }
}


// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/Settings/actions/index.js